import { useState } from 'react';
import { uniqueId } from 'lodash';

export const useUniqueId = (prefix: string): string => {
    const [uid] = useState(() => uniqueId(prefix));
    return uid;
};

export default useUniqueId;
